export const CrownMark = ({ className = "w-10 h-8" }) => (
  <svg viewBox="0 0 64 52" className={className} aria-hidden="true" data-testid="crown-mark">
    <defs>
      <linearGradient id="crownGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F5D76E" />
        <stop offset="0.5" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#9A7B1E" />
      </linearGradient>
    </defs>
    <path d="M6 38 L12 14 L24 26 L32 8 L40 26 L52 14 L58 38 Z" fill="url(#crownGold)" />
    <rect x="6" y="40" width="52" height="6" rx="2" fill="url(#crownGold)" />
    <circle cx="12" cy="11" r="3" fill="#D91604" />
    <circle cx="32" cy="5" r="3" fill="#D91604" />
    <circle cx="52" cy="11" r="3" fill="#D91604" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <a href="#top" data-testid="logo-link" className="group flex items-center gap-3">
    <div className="relative">
      <CrownMark className={compact ? "w-9 h-7" : "w-11 h-9"} />
      <span className="absolute -inset-2 rounded-full bg-gold/0 blur-xl transition-colors duration-500 group-hover:bg-gold/20" />
    </div>
    <div className="leading-none">
      <span className="block font-serif text-lg sm:text-xl font-semibold tracking-wide text-white">
        O REI <span className="gold-text italic">da 25</span>
      </span>
      <span className="mt-1 block text-[10px] font-sans uppercase tracking-[0.35em] text-neutral-500">
        oreida25.com.br
      </span>
    </div>
  </a>
);
